import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-multi-shipment-screen',
    template: ` <rt-trip-error-multi [ormIds]="ids$ | async"></rt-trip-error-multi>`,
})
export class InterfaceValidationMultiScreenComponent implements OnInit {
    ids$: Observable<number[]>;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.ids$ = this.route.queryParams.pipe(map((params) => params['ids'].split(',') || null));
    }
}
